module.exports = __webpack_public_path__ + "img/blueJ_logo.8b05f7a6.svg";